(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DataFormatter", [], factory);
	else if(typeof exports === 'object')
		exports["DataFormatter"] = factory();
	else
		root["DataFormatter"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty2 = __webpack_require__(1);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _utils = __webpack_require__(22);
	
	var _enUS = __webpack_require__(64);
	
	var _enUS2 = _interopRequireDefault(_enUS);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultLocaleName = 'en-US';
	
	module.exports = function () {
	
	  /**
	   * Constructor
	   * Available options are:
	   *   debug {boolean} - enable debug mode
	   *   UTCOffset {number|null} - UTC offset for dates in minutes
	   *   locale {string}
	   *   transformCode {function} - code transformer
	   * @param {object} options
	   */
	  function DataFormatter() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$debug = _ref.debug,
	        debug = _ref$debug === undefined ? false : _ref$debug,
	        _ref$UTCOffset = _ref.UTCOffset,
	        UTCOffset = _ref$UTCOffset === undefined ? null : _ref$UTCOffset,
	        _ref$locale = _ref.locale,
	        locale = _ref$locale === undefined ? defaultLocaleName : _ref$locale,
	        _ref$transformCode = _ref.transformCode,
	        transformCode = _ref$transformCode === undefined ? function (code) {
	      return code;
	    } : _ref$transformCode,
	        _ref$locales = _ref.locales,
	        locales = _ref$locales === undefined ? [] : _ref$locales;
	
	    (0, _classCallCheck3.default)(this, DataFormatter);
	
	
	    this.memoized = {};
	    this.debug = debug;
	    this.UTCOffset = UTCOffset;
	    this.transformCode = transformCode;
	    this.zeroDate = this.createDate('1899-12-31T00:00:00.000');
	
	    // Save defined locales
	    this.locales = (0, _defineProperty3.default)({}, defaultLocaleName, _enUS2.default);
	    this.defineLocales(locales);
	
	    // Set default locale
	    this.setLocale(locale);
	  }
	
	  /**
	   * Resets memoized pattern functions
	   */
	
	
	  (0, _createClass3.default)(DataFormatter, [{
	    key: 'clearMemoizedFunctions',
	    value: function clearMemoizedFunctions() {
	      this.memoized = {};
	    }
	
	    /**
	     * Defines locales
	     * @param  {array} locales
	     */
	
	  }, {
	    key: 'defineLocales',
	    value: function defineLocales(locales) {
	      var _this = this;
	
	      locales.forEach(function (locale) {
	        return _this.locales[locale.name] = locale;
	      });
	    }
	
	    /**
	     * Sets locale
	     * If locale doesn't exist, sets default
	     * @param {string} locale
	     */
	
	  }, {
	    key: 'setLocale',
	    value: function setLocale(locale) {
	      this.locale = this.locales[locale] || this.locales[defaultLocaleName];
	      this.clearMemoizedFunctions();
	    }
	
	    /**
	     * Sets UTC offset for dates
	     * @param {number|null} UTCOffset in minutes
	     */
	
	  }, {
	    key: 'setUTCOffset',
	    value: function setUTCOffset(UTCOffset) {
	      this.UTCOffset = UTCOffset;
	    }
	
	    /**
	     * Creates new date instance
	     */
	
	  }, {
	    key: 'createDate',
	    value: function createDate() {
	      var date = new (Function.prototype.bind.apply(Date, [null].concat(Array.prototype.slice.call(arguments))))();
	
	      if (this.UTCOffset !== null) {
	        var clientOffset = date.getTimezoneOffset();
	        var newOffset = this.UTCOffset + clientOffset;
	        var newOffsetMs = newOffset * 60 * 1000;
	
	        date.setTime(date.getTime() + newOffsetMs);
	      }
	
	      return date;
	    }
	
	    /**
	     * Logger
	     */
	
	  }, {
	    key: 'log',
	    value: function log(message) {
	      if (this.debug) {
	        console.log(message);
	      }
	    }
	
	    /**
	     * Rounds value
	     * @param  {[type]} n        Value to be round
	     * @param  {[type]} decimals Amount of decimal digits
	     * @return {number}          Rounded value
	     */
	
	  }, {
	    key: 'roundDecimals',
	    value: function roundDecimals(n, decimals) {
	      var pow = Math.pow(10, decimals);
	      return Math.round(n * pow) / pow;
	    }
	
	    /**
	     * Greatest common divisor
	     */
	
	  }, {
	    key: 'gcd',
	    value: function gcd(a, b) {
	      var r = void 0;
	      while (b) {
	        r = a % b;
	        a = b;
	        b = r;
	      }
	      return Math.abs(a);
	    }
	  }, {
	    key: 'applyNumberPattern',
	    value: function applyNumberPattern(n, pattern, direction) {
	      n = n.toString();
	      var s = '';
	
	      if (direction === 'right') {
	        var j = 0;
	        var i = -1;
	        var patLen = pattern.length;
	
	        while (++i < patLen) {
	          switch (pattern[i]) {
	            case '0':
	              s += n[j] || '0';
	              j++;
	              break;
	            case '#':
	              s += n[j] || '';
	              j++;
	              break;
	            case '?':
	              s += n[j] || ' ';
	              j++;
	              break;
	            case '[':
	              while (i < pattern.length && pattern[i] !== ']') {
	                s += pattern[i];
	                i++;
	              }
	              i--;
	              break;
	            default:
	              s += pattern[i];
	          }
	        }
	      } else {
	        // Should separate thousands
	        var separateThousands = false;
	        var mostLeftDigit = void 0;
	
	        pattern = pattern.replace(/(0|#|\?)(,+?)(0|#|\?)/g, function (a, m1, m2, m3) {
	          separateThousands = true;
	          return m1 + m3;
	        });
	
	        // Add separation
	        if (separateThousands) {
	          var _j2 = n.length - 3;
	          while (n[0] === '-' ? _j2 > 1 : _j2 > 0) {
	            n = n.substr(0, _j2) + this.locale.thousandSeparator + n.substr(_j2);
	            _j2 -= 3;
	          }
	        }
	
	        var _j = n.length - 1;
	        var _i = pattern.length;
	
	        n = n === '0' ? '' : n;
	
	        while (_i--) {
	          switch (pattern[_i]) {
	            case '0':
	              s = (n[_j] || '0') + s;
	              mostLeftDigit = _i;
	              _j--;
	              break;
	            case '#':
	              s = (n[_j] || '') + s;
	              mostLeftDigit = _i;
	              _j--;
	              break;
	            case '?':
	              s = (n[_j] || ' ') + s;
	              mostLeftDigit = _i;
	              _j--;
	              break;
	            case ']':
	              while (_i > 0 && pattern[_i] !== '[') {
	                s = pattern[_i] + s;
	                _i--;
	              }
	              _i++;
	              break;
	            default:
	              s = pattern[_i] + s;
	          }
	        }
	        // Add remaining digits, example: n=1234, ptrn=00, result must be 1234 instead of 34
	        if (_j >= 0 && mostLeftDigit !== null) {
	          s = s.substr(0, mostLeftDigit) + n.substr(0, _j + 1) + s.substr(mostLeftDigit);
	        }
	      }
	
	      return s;
	    }
	  }, {
	    key: 'restoreOrigins',
	    value: function restoreOrigins(value, origins) {
	      return value.toString().replace(/\[(?:(\$*?)|(.*?))\]/g, function (a, m1) {
	        return m1 && origins[m1.length - 1] || a;
	      });
	    }
	  }, {
	    key: 'formatAsNumberDecimal',
	    value: function formatAsNumberDecimal(n, decimals, patternIntegerPart, patternDecimalPart) {
	
	      n = this.roundDecimals(n, decimals).toString().split('.');
	      var integerPart = n[0];
	      var decimalPart = n[1] || 0;
	
	      return this.applyNumberPattern(integerPart, patternIntegerPart) + this.locale.decimalSeparator + this.applyNumberPattern(decimalPart, patternDecimalPart, 'right');
	    }
	  }, {
	    key: 'formatAsNumberFractial',
	    value: function formatAsNumberFractial(n, patternNumeratorPart, patternDenominatorPart) {
	      var m = n.toString().split(".");
	      m = m[1] ? Math.pow(10, m[1].length) : 1;
	      n = Math.floor(n * m);
	
	      var factor = this.gcd(n, m);
	
	      return this.applyNumberPattern(n / factor, patternNumeratorPart) + '/' + this.applyNumberPattern(m / factor, patternDenominatorPart);
	    }
	  }, {
	    key: 'formatAsNumberFractialMixed',
	    value: function formatAsNumberFractialMixed(n, leftPatternNumeratorPart, rightPatternNumeratorPart, patternDenominatorPart) {
	      var f = 0;
	      var c = 1;
	      var factor = 1;
	      var m = n.toString().split('.');
	
	      if (m[1]) {
	        c = Math.pow(10, m[1].length);
	        f = parseInt(m[1]);
	        factor = this.gcd(f, c);
	      }
	
	      return this.applyNumberPattern(parseInt(n), leftPatternNumeratorPart) + this.applyNumberPattern(f / factor, rightPatternNumeratorPart) + '/' + this.applyNumberPattern(c / factor, patternDenominatorPart);
	    }
	  }, {
	    key: 'formatAsNumberExponential',
	    value: function formatAsNumberExponential(n, integerPartLength, decimalPartLength, patternIntegerPart, patternDecimalPart, patternPowPart) {
	
	      var sign = n < 0 ? -1 : 1;
	      var pow = 0;
	
	      if (n !== 0) {
	
	        n = Math.abs(n);
	
	        var integerPartDivision = Math.pow(10, integerPartLength);
	
	        while (n < integerPartDivision || this.roundDecimals(n, decimalPartLength) < integerPartDivision) {
	          n *= 10;
	          pow++;
	        }
	
	        while (n >= integerPartDivision || this.roundDecimals(n, decimalPartLength) >= integerPartDivision) {
	          n /= 10;
	          pow--;
	        }
	      }
	
	      n = this.roundDecimals(n * sign, decimalPartLength).toString().split('.');
	
	      // Build res
	      var res = '';
	
	      // Integer part
	      res += this.applyNumberPattern(parseInt(n[0]), patternIntegerPart);
	
	      // Decimal part
	      if (patternDecimalPart) {
	        res += this.locale.decimalSeparator + this.applyNumberPattern(parseInt(n[1] || 0), patternDecimalPart, 'right');
	      }
	
	      // Pow part
	      res += 'E' + (pow > 0 ? '-' : '+') + this.applyNumberPattern(Math.abs(pow), patternPowPart);
	
	      return res;
	    }
	  }, {
	    key: 'formatAsDateTimeElapsed',
	    value: function formatAsDateTimeElapsed(n, foundDays, foundHours, foundMinutes, pattern) {
	      var _this2 = this;
	
	      n = Math.abs(n.getTime() - this.zeroDate.getTime());
	
	      var seconds = parseInt(n / 1000);
	      var minutes = parseInt(seconds / 60);
	      var hours = parseInt(minutes / 60);
	      var days = parseInt(hours / 24);
	
	      hours = foundDays ? hours % 24 : hours;
	      minutes = foundHours ? minutes % 60 : minutes;
	      seconds = foundMinutes ? seconds % 60 : seconds;
	
	      return pattern.replace(/(dd)|(d)|(hh)|(h)|(mm)|(m)|(ss)|(s)/gi, function (a, dd, d, hh, h, mm, m, ss, s) {
	
	        if (dd) {
	          return _this2.applyNumberPattern(days, '00');
	        }
	
	        if (d) {
	          return days;
	        }
	
	        if (hh) {
	          return _this2.applyNumberPattern(hours, '00');
	        }
	
	        if (h) {
	          return hours;
	        }
	
	        if (mm) {
	          return _this2.applyNumberPattern(minutes, '00');
	        }
	
	        if (m) {
	          return minutes;
	        }
	
	        if (ss) {
	          return _this2.applyNumberPattern(seconds, '00');
	        }
	
	        if (s) {
	          return seconds;
	        }
	
	        return '';
	      });
	    }
	  }, {
	    key: 'formatAsDateTimeNormal',
	    value: function formatAsDateTimeNormal(n, pattern) {
	      var _this3 = this;
	
	      var _locale = this.locale,
	          days = _locale.days,
	          daysShort = _locale.daysShort,
	          months = _locale.months,
	          monthsShort = _locale.monthsShort;
	
	      var foundAMPM = false;
	
	      var year = n.getFullYear();
	      var month = n.getMonth();
	      var date = n.getDate();
	      var weekDay = n.getDay();
	      var hours = n.getHours();
	      var minutes = n.getMinutes();
	      var seconds = n.getSeconds();
	
	      // Build res
	      var res = pattern.replace(/((?:am\/pm)|(?:a\/p))|(?:(h[^ydsap]*?)mm)|(?:mm([^ydh]*?s))|(?:(h[^ydsap]*?)m)|(?:m([^ydh]*?s))/gi, function (a, ampm, fmin, fmin2, mmin, mmin2) {
	
	        if (ampm) {
	          foundAMPM = true;
	          return '[]';
	        }
	
	        if (fmin) {
	          return fmin + _this3.applyNumberPattern(minutes, '00');
	        }
	
	        if (fmin2) {
	          return _this3.applyNumberPattern(minutes, '00') + fmin2;
	        }
	
	        if (mmin) {
	          return mmin + minutes;
	        }
	
	        if (mmin2) {
	          return minutes + mmin2;
	        }
	
	        return '';
	      });
	
	      return res.replace(/(ss)|(s)|(hh)|(h)|(dddd)|(ddd)|(dd)|(d)|(mmmmm)|(mmmm)|(mmm)|(mm)|(m)|(yyyy)|(yy)|(\[\])/gi, function (a, ss, s, hh, h, dddd, ddd, dd, d, mmmmm, mmmm, mmm, mm, m, yyyy, yy, ampm) {
	
	        if (ss) {
	          return _this3.applyNumberPattern(seconds, '00');
	        }
	
	        if (s) {
	          return seconds;
	        }
	
	        if (hh) {
	          return _this3.applyNumberPattern(foundAMPM ? hours % 12 : hours, '00');
	        }
	
	        if (h) {
	          return foundAMPM ? hours % 12 : hours;
	        }
	
	        if (dddd) {
	          return days[weekDay];
	        }
	
	        if (ddd) {
	          return daysShort[weekDay];
	        }
	
	        if (dd) {
	          return _this3.applyNumberPattern(date, '00');
	        }
	
	        if (d) {
	          return date;
	        }
	
	        if (mmmmm) {
	          return monthsShort[month][0];
	        }
	
	        if (mmmm) {
	          return months[month];
	        }
	
	        if (mmm) {
	          return monthsShort[month];
	        }
	
	        if (mm) {
	          return _this3.applyNumberPattern(month + 1, '00');
	        }
	
	        if (m) {
	          return month + 1;
	        }
	
	        if (yyyy) {
	          return year;
	        }
	
	        if (yy) {
	          return year.toString().substr(2);
	        }
	
	        if (ampm) {
	          return hours < 12 ? 'AM' : 'PM';
	        }
	
	        return '';
	      });
	    }
	  }, {
	    key: 'createTextCode',
	    value: function createTextCode(section) {
	      var code = new _utils.Code();
	
	      code.append('\n      result.value = {0}.replace(/@/, n);\n    ', section);
	
	      return code.toString();
	    }
	  }, {
	    key: 'createGeneralCode',
	    value: function createGeneralCode() {
	      var code = new _utils.Code();
	      var numberCode = this.createNumberCode('#.00');
	      var dateTimeCode = this.createDateTimeCode('[d]');
	
	      code.append('\n      if (type === "Number") {\n        ' + numberCode + '\n      }\n      if (type === "DateTime") {\n        ' + dateTimeCode + '\n      }\n    ');
	
	      return code.toString();
	    }
	  }, {
	    key: 'createNumberExponentialCode',
	    value: function createNumberExponentialCode(exponentialMatch) {
	      var patternIntegerPart = exponentialMatch[1];
	      var patternDecimalPart = exponentialMatch[2];
	      var patternPowPart = exponentialMatch[3];
	      var code = new _utils.Code();
	      var integerPartLength = void 0;
	      var decimalPartLength = void 0;
	
	      var zerosCount = function zerosCount(s) {
	        return s.match(/0|\?|#/g).length;
	      };
	
	      // Integer part
	      if (!patternIntegerPart) {
	        patternIntegerPart = '#';
	        integerPartLength = 1;
	      } else {
	        integerPartLength = zerosCount(patternIntegerPart);
	      }
	
	      // Decimal part
	      if (!patternDecimalPart) {
	        patternDecimalPart = '';
	        decimalPartLength = 0;
	      } else {
	        decimalPartLength = zerosCount(patternDecimalPart);
	      }
	
	      code.append('\n      result.value = this.formatAsNumberExponential(n, {0}, {1}, {2}, {3}, {4});\n    ', integerPartLength, decimalPartLength, patternIntegerPart, patternDecimalPart, patternPowPart);
	
	      return code.toString();
	    }
	  }, {
	    key: 'createNumberFractialCode',
	    value: function createNumberFractialCode(fractialMatch) {
	      var code = new _utils.Code();
	      var patternNumeratorPart = fractialMatch[1] || '#';
	      var patternDenominatorPart = fractialMatch[2] || '#';
	      // TODO watch here
	      var zeroPos = patternNumeratorPart.length - 1;
	
	      while (patternNumeratorPart[zeroPos] === '0' && patternNumeratorPart[zeroPos] !== '?' && patternNumeratorPart[zeroPos] !== '#' && patternNumeratorPart[zeroPos] !== ' ' && zeroPos > 0) {
	        zeroPos--;
	      }
	
	      var leftPatternNumeratorPart = patternNumeratorPart.substr(0, zeroPos);
	      var rightPatternNumeratorPart = patternNumeratorPart.substr(zeroPos);
	
	      if (!leftPatternNumeratorPart) {
	        code.append('\n        result.value = this.formatAsNumberFractial(n, {0}, {1});\n      ', rightPatternNumeratorPart, patternDenominatorPart);
	      }
	      // Mixed fraction
	      else {
	          code.append('\n        result.value = this.formatAsNumberFractialMixed(n, {0}, {1}, {2});\n      ', leftPatternNumeratorPart, rightPatternNumeratorPart, patternDenominatorPart);
	        }
	
	      return code.toString();
	    }
	  }, {
	    key: 'createNumberDecimalCode',
	    value: function createNumberDecimalCode(decimalMatch) {
	      var code = new _utils.Code();
	      var patternIntegerPart = decimalMatch[1] || '0';
	      var patternDecimalPart = decimalMatch[2] || '';
	      var decimals = void 0;
	      var factor = 1;
	
	      var zerosCount = function zerosCount(s) {
	        return s.match(/0|\?|#/g).length;
	      };
	
	      if (!patternDecimalPart) {
	        decimals = 0;
	      } else {
	        decimals = zerosCount(patternDecimalPart);
	      }
	
	      // Spaces before .
	      patternIntegerPart = patternIntegerPart.replace(/(0|#|\?)(,+)([^0?#]*)$/, function (a, m1, m2, m3) {
	        factor *= Math.pow(1000, m2.length);
	        return m1 + m3;
	      });
	
	      if (factor !== 1) {
	        code.append('\n        n /= {0};\n      ', factor);
	      }
	
	      code.append('\n      result.value = this.formatAsNumberDecimal(n, {0}, {1}, {2});\n    ', decimals, patternIntegerPart, patternDecimalPart);
	
	      return code.toString();
	    }
	  }, {
	    key: 'createNumberIntegerCode',
	    value: function createNumberIntegerCode(section) {
	      var code = new _utils.Code();
	
	      code.append('\n      n = Math.round(n);\n      result.value = this.applyNumberPattern(n, {0});\n    ', section);
	
	      return code.toString();
	    }
	  }, {
	    key: 'createNumberCode',
	    value: function createNumberCode(section, shouldAbsNumber) {
	      var numberCode = new _utils.Code();
	
	      // Abs
	      if (shouldAbsNumber) {
	        numberCode.append('\n        n = Math.abs(n);\n      ');
	      }
	
	      // Exponential form regexp
	      var exponentialMatch = section.match(/(.*?)(?:\.(.*?))?e(?:\+|\-)(.*)/i);
	
	      if (exponentialMatch) {
	
	        // Exponential form
	        numberCode.append(this.createNumberExponentialCode(exponentialMatch));
	      } else {
	        var factor = 1;
	
	        // Spaces before end and decimal separator (.)
	        section = section.replace(/(0|#|\?)([\s,]+)([^0?#]*?)($|\.)/, function (a, m1, m2, m3, m4) {
	          factor *= Math.pow(1000, m2.length);
	          return m1 + m3 + m4;
	        });
	
	        // Percents
	        var percentMatch = section.match(/%/g);
	        if (percentMatch) {
	          factor /= Math.pow(100, percentMatch.length);
	        }
	
	        // Factor
	        if (factor !== 1) {
	          numberCode.append('\n          n /= {0};\n        ', factor);
	        }
	
	        var fractialMatch = void 0;
	        var decimalMatch = void 0;
	
	        switch (true) {
	
	          // Fractial form
	          case !!(fractialMatch = section.match(/(.*?)\/(.*)/)):
	            numberCode.append(this.createNumberFractialCode(fractialMatch));
	            break;
	
	          // Decimal form
	          case !!(decimalMatch = section.match(/(.*?)\.(.*)/)):
	            numberCode.append(this.createNumberDecimalCode(decimalMatch));
	            break;
	
	          // Integer form
	          default:
	            numberCode.append(this.createNumberIntegerCode(section));
	
	        }
	      }
	
	      // Final code
	      var code = new _utils.Code();
	
	      // Parse to float
	      code.append('\n      n = parseFloat(n);\n    ');
	
	      // Checks
	      code.append('\n      if (!isNaN(n)) {\n        if (n >= 1e21 || n <= -1e21) {\n          result.value = n.toString().toUpperCase();\n        }\n        else {\n          ' + numberCode + '\n        }\n      }\n    ');
	
	      return code.toString();
	    }
	  }, {
	    key: 'createDateTimeElapsedCode',
	    value: function createDateTimeElapsedCode(section) {
	      var code = new _utils.Code();
	
	      var foundDays = /d/i.test(section);
	      var foundHours = /h/i.test(section);
	      var foundMinutes = /m/i.test(section);
	
	      code.append('\n      result.value = this.formatAsDateTimeElapsed(n, {0}, {1}, {2}, {3});\n    ', foundDays, foundHours, foundMinutes, section);
	
	      return code.toString();
	    }
	  }, {
	    key: 'createDateTimeNormalCode',
	    value: function createDateTimeNormalCode(section) {
	      var code = new _utils.Code();
	
	      code.append('\n      result.value = this.formatAsDateTimeNormal(n, {0});\n    ', section);
	
	      return code.toString();
	    }
	  }, {
	    key: 'createDateTimeCode',
	    value: function createDateTimeCode(section) {
	      var code = new _utils.Code();
	      var elapsed = false;
	
	      section = section.replace(/\[(h+?|m+?|s+?|y+?|d+?)]/ig, function (a, m1) {
	        elapsed = true;
	        return m1;
	      });
	
	      var dateTimeCode = elapsed ? this.createDateTimeElapsedCode(section) : this.createDateTimeNormalCode(section);
	
	      code.append('\n      n = this.createDate(n);\n      if (!isNaN(n.getTime())) {\n        ' + dateTimeCode + '\n      }\n    ');
	
	      return code.toString();
	    }
	  }, {
	    key: 'createSectionCode',
	    value: function createSectionCode(section, sectionIndex, sectionsCount) {
	      // Start creating code for function
	      var code = new _utils.Code();
	
	      var condition = void 0;
	      var shouldAbsNumber = false;
	
	      // Find condition for sector or add standard sector condition (positive number, negative number, etc.)
	      var conditionMatch = section.match(/\[((?:>|>=|<|<=|=|<>)[0-9\.]+?)]/);
	
	      switch (true) {
	
	        // Found condition
	        case !!conditionMatch:
	          var cond = conditionMatch[1].replace(/<>/, '!=').replace('/=/', '==');
	          condition = 'type == "Number" && parseFloat(n)' + cond;
	          break;
	
	        // Standard condition for first section of 3+
	        case sectionIndex === 0 && sectionsCount > 2:
	          condition = 'type == "Number" && parseFloat(n) > 0';
	          break;
	
	        // Standard condition for first section of 2
	        case sectionIndex === 0 && sectionsCount === 2:
	          condition = 'type == "Number" && parseFloat(n) >= 0';
	          break;
	
	        // Standard condition for negative number
	        case sectionIndex === 1:
	          condition = 'type == "Number" && parseFloat(n) < 0';
	          shouldAbsNumber = true;
	          break;
	
	      }
	
	      // Find text color
	      section = section.replace(/\[(Red|Green|White|Blue|Magenta|Yellow|Cyan|Black)]/gi, function (a, m1) {
	        code.append('\n        result.color = {0};\n      ', m1);
	        return '';
	      });
	
	      // Remove all [], except our replacements and elapsed days, hours, minutes, seconds
	      section = section.replace(/(\[((?!((\$*?)|(d*?)|(h*?)|(m*?)|(s*?))]).*?)])/, '');
	
	      // Format code
	      var formatCode = new _utils.Code();
	
	      // Defaults
	      formatCode.append('\n      result.value = {0};\n      result.pattern = {0};\n    ', section);
	
	      switch (true) {
	
	        // General format
	        case /General/i.test(section):
	          formatCode.append(this.createGeneralCode(section));
	          break;
	
	        // Text
	        case /@/.test(section):
	          formatCode.append(this.createTextCode(section));
	          break;
	
	        // Number
	        case /#|\?|0/.test(section):
	          if (!condition) {
	            condition = 'type === "Number"';
	          }
	          formatCode.append(this.createNumberCode(section, shouldAbsNumber));
	          break;
	
	        // DateTime
	        case /h|m|s|y|d/i.test(section):
	          if (!condition) {
	            condition = 'type === "DateTime"';
	          }
	          formatCode.append(this.createDateTimeCode(section));
	          break;
	
	      }
	
	      // Add return statement
	      formatCode.append('\n      return makeResult.call(this);\n    ');
	
	      // Build final section code
	      if (condition) {
	        code.append('\n        // Section\n        if (' + condition + ') {\n          ' + formatCode + '\n        }\n        // End section\n      ');
	      } else {
	        code.append('\n        // Section\n        ' + formatCode + '\n        // End section\n      ');
	      }
	
	      return code.toString();
	    }
	  }, {
	    key: 'createPatternCode',
	    value: function createPatternCode(pattern) {
	      var _this4 = this;
	
	      var origins = [];
	      var replaces = '';
	
	      // Find quotes, slash symbols
	      var patternReplaced = pattern.replace(/"([^"]+)"|\\(.?)|(_.?)|(\*.?)|(")/g, function (a, m1, m2, m3) {
	        // Quote found
	        if (m1) {
	          origins.push(m1.replace(/("|'|\\)/g, "\\$1"));
	          return '[' + (replaces += '$') + ']';
	        }
	        // Slash found
	        if (m2) {
	          origins.push(m2.replace(/("|'|\\)/g, "\\$1"));
	          return '[' + (replaces += '$') + ']';
	        }
	        // Space found
	        if (m3) {
	          origins.push(' ');
	          return '[' + (replaces += '$') + ']';
	        }
	        return '';
	      });
	
	      // Split pattern to sections
	      var sections = patternReplaced.split(/;/);
	
	      // Init code
	      var code = new _utils.Code();
	
	      // Start variables
	      code.append('\n      var result = {\n        value: "",\n        align: type === "Number" || type === "DateTime" ? "right" : "",\n        color: "",\n        pattern: ""\n      };\n\n      function makeResult() {\n        var origins = {0};\n        result.value = this.restoreOrigins(result.value, origins);\n        result.pattern = this.restoreOrigins(result.pattern, origins);\n        return result;\n      };\n    ', origins);
	
	      // Remove unnesessary sections
	      sections = sections.slice(0, 4);
	
	      // Loop trough sections
	      sections.forEach(function (section, sectionIndex) {
	        return code.append(_this4.createSectionCode(section, sectionIndex, sections.length));
	      });
	
	      // Return statement
	      code.append('\n      result.value = {0};\n      result.pattern = {0};\n      return makeResult.call(this);\n    ', patternReplaced);
	
	      return code.toString();
	    }
	  }, {
	    key: 'format',
	    value: function format(n, type, pattern) {
	      this.log('Input:');
	      this.log('n = ' + n + ', type = ' + type + ', pattern = ' + pattern);
	
	      n = n.toString();
	      pattern = pattern.toString();
	
	      // Find predefined format
	      if (this.locale.formats[pattern]) {
	        pattern = this.locale.formats[pattern];
	      }
	
	      // Create function
	      if (!this.memoized[pattern]) {
	        var code = this.createPatternCode(pattern);
	
	        // Transform code
	        code = this.transformCode(code);
	
	        // Memoize function
	        this.memoized[pattern] = Function('n', 'type', code);
	
	        // Log code
	        this.log('Code:');
	        this.log(code);
	      }
	
	      // Call function
	      var result = this.memoized[pattern].call(this, n, type);
	
	      // Log result
	      this.log('Result:');
	      this.log(result);
	
	      return result;
	    }
	  }]);
	  return DataFormatter;
	}();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(2);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(3), __esModule: true };

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(4);
	var $Object = __webpack_require__(7).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(5);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(15), 'Object', { defineProperty: __webpack_require__(11).f });


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var core = __webpack_require__(7);
	var ctx = __webpack_require__(8);
	var hide = __webpack_require__(10);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(9);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var createDesc = __webpack_require__(19);
	module.exports = __webpack_require__(15) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var IE8_DOM_DEFINE = __webpack_require__(14);
	var toPrimitive = __webpack_require__(18);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(15) && !__webpack_require__(16)(function () {
	  return Object.defineProperty(__webpack_require__(17)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(16)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var document = __webpack_require__(6).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(2);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Code = undefined;
	
	var _toConsumableArray2 = __webpack_require__(23);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _stringify = __webpack_require__(62);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(20);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(21);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.formatString = formatString;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Format string like sprintf() in PHP
	 */
	function formatString(s) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return s.replace(/{(\d+)}/g, function (match, number) {
	    return typeof args[number] != 'undefined' ? args[number] : match;
	  });
	}
	
	/**
	 * Class for building code
	 */
	
	var Code = exports.Code = function () {
	  function Code() {
	    (0, _classCallCheck3.default)(this, Code);
	
	    this.code = '';
	  }
	
	  (0, _createClass3.default)(Code, [{
	    key: 'makeString',
	    value: function makeString(s) {
	      for (var _len2 = arguments.length, values = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        values[_key2 - 1] = arguments[_key2];
	      }
	
	      values = values.map(_stringify2.default);
	      return formatString.apply(undefined, [s].concat((0, _toConsumableArray3.default)(values)));
	    }
	  }, {
	    key: 'append',
	    value: function append() {
	      this.code += this.makeString.apply(this, arguments);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return this.code;
	    }
	  }]);
	  return Code;
	}();

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(24);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(25), __esModule: true };

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(26);
	__webpack_require__(55);
	module.exports = __webpack_require__(7).Array.from;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(27)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(30)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(28);
	var defined = __webpack_require__(29);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(31);
	var $export = __webpack_require__(5);
	var redefine = __webpack_require__(32);
	var hide = __webpack_require__(10);
	var has = __webpack_require__(33);
	var Iterators = __webpack_require__(34);
	var $iterCreate = __webpack_require__(35);
	var setToStringTag = __webpack_require__(51);
	var getPrototypeOf = __webpack_require__(53);
	var ITERATOR = __webpack_require__(52)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(10);


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(36);
	var descriptor = __webpack_require__(19);
	var setToStringTag = __webpack_require__(51);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(10)(IteratorPrototype, __webpack_require__(52)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(12);
	var dPs = __webpack_require__(37);
	var enumBugKeys = __webpack_require__(49);
	var IE_PROTO = __webpack_require__(46)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(17)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(50).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var anObject = __webpack_require__(12);
	var getKeys = __webpack_require__(38);
	
	module.exports = __webpack_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(39);
	var enumBugKeys = __webpack_require__(49);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(33);
	var toIObject = __webpack_require__(40);
	var arrayIndexOf = __webpack_require__(43)(false);
	var IE_PROTO = __webpack_require__(46)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(41);
	var defined = __webpack_require__(29);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(42);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(40);
	var toLength = __webpack_require__(44);
	var toAbsoluteIndex = __webpack_require__(45);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(28);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(28);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(47)('keys');
	var uid = __webpack_require__(48);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(6).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(11).f;
	var has = __webpack_require__(33);
	var TAG = __webpack_require__(52)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(47)('wks');
	var uid = __webpack_require__(48);
	var Symbol = __webpack_require__(6).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(33);
	var toObject = __webpack_require__(54);
	var IE_PROTO = __webpack_require__(46)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(29);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(8);
	var $export = __webpack_require__(5);
	var toObject = __webpack_require__(54);
	var call = __webpack_require__(56);
	var isArrayIter = __webpack_require__(57);
	var toLength = __webpack_require__(44);
	var createProperty = __webpack_require__(58);
	var getIterFn = __webpack_require__(59);
	
	$export($export.S + $export.F * !__webpack_require__(61)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(12);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(34);
	var ITERATOR = __webpack_require__(52)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(11);
	var createDesc = __webpack_require__(19);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(60);
	var ITERATOR = __webpack_require__(52)('iterator');
	var Iterators = __webpack_require__(34);
	module.exports = __webpack_require__(7).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(42);
	var TAG = __webpack_require__(52)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(52)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(63), __esModule: true };

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(7);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  name: 'en-US',
	  months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
	  monthsShort: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
	  days: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
	  daysShort: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
	  thousandSeparator: ' ',
	  decimalSeparator: '.',
	  formats: {
	    'General Number': '#.#',
	    'Currency': '$ #,##0.00;[Red]$ -#,##0.00',
	    'Fixed': '0.00',
	    'Standard': '#,##0.00',
	    'Percent': '0.00%',
	    'Scientific': '0.00E+00',
	    'Yes/No': '"Yes";"Yes";"No"',
	    'True/False': '"True";"True";"False"',
	    'On/Off': '"On";"On";"Off"',
	    'Short Date': 'mm.dd.yyyy',
	    'Long Date': 'dd mmmm yyyy',
	    'General Date': 'mm.dd.yyyy h:mm',
	    'Medium Date': 'dd.mmm.yy',
	    'Long Time': 'hh:mm:ss AM/PM',
	    'Short Time': 'h:mm',
	    'Medium Time': 'hh:mm AM/PM'
	  }
	};

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// index.js